import { defer, type LoaderFunctionArgs } from "react-router-dom";
import { resolveLoaderResult } from "@/routes/loaderResult";
import { getLimitPage } from "../common/service";

export function limitSetLoader({ request }: LoaderFunctionArgs) {
  const type = new URL(request.url).searchParams.get("type") || "";
  return defer({
    coreData: resolveLoaderResult(getLimitPage({ type })),
  });
}
